import { NavigationEnd, Router } from "@angular/router";
import { EventEmitter, Injectable } from "@angular/core";
import { ModalModel } from "../models/modalModel";
import { ErrorModalComponent, ErrorModalMessage } from '../app/components/shared/error/error-modal.component';

@Injectable()
export class UiService {
  // public isLoggedIn: boolean = false;
  public isLoggedIn: boolean = true;
  public currentRoute: string[] | undefined;
  public displayPortalNav: boolean = true;
  public modalInstances: ModalModel[] = [];
  public isModalActive: boolean = this.modalInstances.length > 0;
  public modalResponse = new EventEmitter<any>();

  constructor(private router: Router) {
    this.router.events.subscribe( event => {
      if( event instanceof NavigationEnd ) {
        this.currentRoute =  event.url.split('/').filter( r => r !== '');
        this.displayPortalNav = this.currentRoute[0] === 'portal';

        if ( sessionStorage.getItem('familyId') ) this.isLoggedIn = true;
      }
    });
  }

  public hideSubnav() {
    // Hide mobile sidenav on checkout
    if (this.router.url.includes('cart') || this.router.url.includes('checkout')) {
      return true;
    }
    return false;
  }


  public navigateTo(route:any, event:any) {
    if( event ) {
      event.preventDefault();
      event.stopPropagation();
    }
    if( !Array.isArray(route) ) route = [route];
    this.router.navigate([...route]);
  }

  isThatRoute(whichRoute:any) {
    if( Array.isArray(whichRoute) ) return;
    return  
      // this.currentRoute.includes(whichRoute); // Need to check for currentRoute condition
  }

  public addModal(opts: ModalModel) {
    this.modalInstances.push(opts);
  }

  public removeModal(ref?: { name: string; }) {
    if(!ref) this.modalInstances.pop();
    if(ref) {
      const index = this.modalInstances.findIndex( modal => modal.component.name === ref.name );
      this.modalInstances.splice(index, 1);
    }
  }

  public getModalData(): any {
    return this.modalInstances.slice(-1)[0].data;
  }

  public getModal(): ModalModel {
    return this.modalInstances.slice(-1)[0]
  }

  public onFocusInput() {
    document.body.classList.add('hide-isi');
  }

  public onBlurInput()  {
    document.body.classList.remove('hide-isi');
  }

  public ErrorPopup(error?: ErrorModalMessage, errors?: ErrorModalMessage[], errorTitle?: string, errorMessage?: string) {
    let errorModel = error ? error :
                     errorMessage ? new ErrorModalMessage(errorMessage, errorTitle) : null;
    this.addModal({
      component: ErrorModalComponent,
      data: { error: errorModel, errors: errors }
    });
  }
}
